import React from "react"

import Link from "./link"

const EmailMe = ({ children }) => (
  <Link to="mailto:testingliveview@germanvelasco.com">{children}</Link>
)

export default EmailMe
